module.exports = __webpack_public_path__ + "media/images/emblems/Jaun-coat_of_arms-9adbf60e9795c2ea513f493d7a656de4.svg";